import { isValNull } from "../../utils";

export const handleValidations = (state) => {
  //state = initialstate,launch_now,launchState,activeFEIdFile,activeFiles,actionType
  //if actionType->create -> check all basic validations and apk validations and launch now validations
  //if actionType->edit -> check only basic validations
  const {
    initialState,
    activeFiles,
    actionType,
    launch_now,
    launchState,
    activeFEIdFile,
  } = state;
  const errors = [];
  const mandatoryFields = {
    version: {
      dependentOn: "",
    },
    release_type: {
      dependentOn: "",
    },
    soft_launch_valid_till: {
      dependentOn: "release_type",
      dependentValue: "SOFT",
    },
    soft_launch_max_attempts: {
      dependentOn: "release_type",
      dependentValue: "SOFT",
    },
  };
  const formState = initialState;
  formState &&
    Object.keys(formState).forEach((key) => {
      if (mandatoryFields[key]) {
        if (mandatoryFields[key].dependentOn == "") {
          if (isValNull(formState[key])) {
            errors.push(`Please enter ${key.split("_").join(" ")} value`);
          }
        } else {
          if (
            !isValNull(formState[mandatoryFields[key].dependentOn]) &&
            formState[mandatoryFields[key].dependentOn] ===
              mandatoryFields[key].dependentValue
          ) {
            if (isValNull(formState[key])) {
              errors.push(`Please enter ${key.split("_").join(" ")} value`);
            }
          }
        }
      }
    });
  // if (actionType === "create" && activeFiles.length == 0) {
  //   errors.push("Please upload apk files");
  // }
  if (launch_now) {
    if (launchState.city_ids.length == 0 && activeFEIdFile === "") {
      errors.push(
        "Please either select city Ids to launch in or upload driver FE Ids"
      );
    }
  }
  return errors;
};
